import { Button, DialogActions } from "@mui/material";
import { isEmpty } from "lodash-es";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import type { EditorLinkData } from "../../plugins/toolbar/hooks/use-link-button-on-click";
import type { Link } from "./types";
import type { FC } from "react";

export const LinkFormActions: FC<{
  onRemove: () => void;
  onCancel: () => void;
  data: Pick<EditorLinkData, "mode" | "url">;
  disabled?: boolean;
}> = ({ onRemove, onCancel, data: { mode, url }, disabled }) => {
  const { reset } = useFormContext<Link>();

  const remove = useCallback(() => {
    onRemove();
    reset();
  }, [onRemove, reset]);

  const cancel = useCallback(() => {
    onCancel();
    reset();
  }, [onCancel, reset]);

  return (
    <DialogActions sx={{ pt: 0 }}>
      {mode === "edit" && !isEmpty(url) && (
        <Button
          data-analytics-id="lexical-link-dialog-remove"
          type="button"
          onClick={remove}
          color="warning"
        >
          Remove Link
        </Button>
      )}
      <Button
        data-analytics-id="lexical-link-dialog-cancel"
        type="button"
        onClick={cancel}
        color="error"
      >
        Cancel
      </Button>
      <Button
        data-analytics-id="lexical-link-dialog-confirm"
        type="submit"
        color="success"
        disabled={disabled}
      >
        Confirm
      </Button>
    </DialogActions>
  );
};
